import React from "react";
import "./App.css";
import Grid from "./components/grid";

function App() {
  return (
    <div className="App">
      <h1 className="title">Game of Life</h1>
      <Grid />
    </div>
  );
}

export default App;
